import { useEffect, useSyncExternalStore } from 'react';
import type { ApiClient, FooterLink } from '../api';
import {
  ensureFooterLinks,
  getFooterLinksSnapshot,
  subscribeFooterLinks,
} from './footerLinksStore';

/**
 * Partner footer links for the current operator. `null` while the first
 * fetch is in flight (footer renders skeleton placeholders), then the list —
 * possibly empty, which the footer treats as "hide me".
 */
export function useFooterLinks(client: ApiClient): FooterLink[] | null {
  useEffect(() => {
    void ensureFooterLinks(client);
  }, [client]);

  return useSyncExternalStore(subscribeFooterLinks, getFooterLinksSnapshot);
}
